import { hasUserRoles, isClinician } from 'user';

const displayLink = (user, __, featureToggles) => {
  return featureToggles?.EnableCBRReport === 'true'
    ? hasUserRoles(user, ['cbrbeta']) || isClinician(user)
    : hasUserRoles(user, ['cbrbeta']);
};
export const ENTRY_LINK = {
  path: '/cbr-dashboard',
  text: 'CBR',
  module: 'cbr-dashboard',
  component: 'Dashboard',
  permission: 'create',
  displayLink: displayLink,
};